import {
  CButton,
  CForm,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from "@coreui/react-pro";
import { Formik } from "formik";
import { useEffect } from "react";
import * as Yup from "yup";
import { ISelectValue } from "../../../shared/shared-interfaces";
import SModal from "../../shared/Modal/SModal";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { AppDispatch } from "../../../store";
import { createEntity, updateEntity } from "./transactionManagement.api";
import { fetching } from "./transactionManagement.reducer";
import {
  mapResponseStatusToColorTransaction,
  mapResponseStatusTransaction,
} from "@/shared/enumeration/ResponseStatus";
import { ToastSuccess } from "@/components/shared/toast/Toast";
import {
  INewTransaction,
  ITransaction,
  statusTransaction,
  typeTransaction,
} from "@/shared/model/transaction.model";

interface IUserUpdateProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  transactionObj?: ITransaction;
}

const UserUpdate = (props: IUserUpdateProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.transactionReducer
  );
  const { updateEntitySuccess } = initialState;
  const { visible, setVisible, transactionObj } = props;
  const handleOnClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (updateEntitySuccess) {
      setVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  const initialValues: INewTransaction = {
    money: 0,
    status: statusTransaction.pendding,
    type: typeTransaction.withdraw,
    userId: 0,
  };

  const validationSchema = Yup.object().shape({
    ball1: Yup.number()
      .required("Không được để trống")
      .test(
        "is-valid-number",
        "Số phải là một số từ 0 đến 9",
        (value) =>
          value !== undefined &&
          Number.isInteger(value) &&
          value >= 0 &&
          value <= 9
      )
      .nullable(),
    ball2: Yup.number()
      .required("Không được để trống")
      .test(
        "is-valid-number",
        "Số phải là một số từ 0 đến 9",
        (value) =>
          value !== undefined &&
          Number.isInteger(value) &&
          value >= 0 &&
          value <= 9
      )
      .nullable(),
    ball3: Yup.number()
      .required("Không được để trống")
      .test(
        "is-valid-number",
        "Số phải là một số từ 0 đến 9",
        (value) =>
          value !== undefined &&
          Number.isInteger(value) &&
          value >= 0 &&
          value <= 9
      )
      .nullable(),
  });

  const returnOption = (
    optionValue: number | null | undefined,
    array: ISelectValue<string>[]
  ) => {
    if (!optionValue) return null;
    if (!array.length) return null;
    return array.find(({ value }) => Number(value) === optionValue);
  };

  const tuChoi = () => {
    if (!transactionObj) return;
    const data = transactionObj;
    data.status = statusTransaction.error;
    dispatch(updateEntity(data as ITransaction));
    setVisible(false);
    ToastSuccess("Từ chối rút tiền thành công");
  };

  const xacNhan = () => {
    if (!transactionObj) return;
    const data = transactionObj;
    data.status = statusTransaction.success;
    dispatch(updateEntity(data as ITransaction));
    setVisible(false);
    ToastSuccess("Duyệt rút tiền thành công");
  };

  return (
    <SModal
      visible={visible}
      onClose={handleOnClose}
      backdrop="static"
      className="custom-modal"
    >
      <>
        <CModalHeader>
          <h4 className="text-center">
            {transactionObj
              ? "Thông tin chi tiết: " + transactionObj.id
              : "Tạo kỳ mới"}
          </h4>
        </CModalHeader>
        <CModalBody>
          <div className="text-center">
            <h3 className="text-center text-danger">Rút</h3>

            <div>Số tiền</div>

            <div
              className="my-2"
              style={{
                fontSize: 30,
                width: "100%",
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                background: "#fafafa",
              }}
            >
              <h5 className="mb-0 py-2">
                {new Intl.NumberFormat("vi-VN").format(
                  transactionObj?.money || 0
                )}
              </h5>
            </div>

            <div className="mt-3">
              {/* Ngân hàng: {transactionObj?.user?.bankName} */}
            </div>
            <div>Số tài khoản: {transactionObj?.user?.cardNumber}</div>
            <div>Chủ tài khoản: {transactionObj?.user?.cardName}</div>
            <div
              className={
                "mt-3 text-" +
                mapResponseStatusToColorTransaction[transactionObj?.status ?? 0]
              }
            >
              Trạng thái:{" "}
              {mapResponseStatusTransaction[transactionObj?.status ?? 0]}
            </div>
          </div>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-center">
          {transactionObj?.status === statusTransaction.pendding ? (
            <>
              <CButton
                className="btn-custom minw-120 variant-gray-300"
                type="button"
                onClick={tuChoi}
              >
                Từ chối
              </CButton>
              <CButton
                className="btn-custom minw-120 primary-500"
                onClick={xacNhan}
              >
                Xác nhận
              </CButton>
            </>
          ) : (
            ""
          )}

          {transactionObj?.status === statusTransaction.error ? (
            <>
              <CButton
                className="btn-custom minw-120 primary-500"
                onClick={xacNhan}
              >
                Xác nhận
              </CButton>
            </>
          ) : (
            ""
          )}

          {transactionObj?.status === statusTransaction.success ? (
            <>
              <CButton
                className="btn-custom minw-120 variant-gray-300"
                type="button"
                onClick={tuChoi}
              >
                Từ chối
              </CButton>
            </>
          ) : (
            ""
          )}
        </CModalFooter>
      </>
    </SModal>
  );
};

export default UserUpdate;
